import IconButton, { IconButtonProps } from './IconButton';

export default IconButton;
export type { IconButtonProps };
